<template>
  <router-link
    :to="to"
    class="py-2 flex flex-col items-center"
    :class="dynamicWrapClass"
  >
    <m-icon :type="icon" size="6" class="mb-1" />
    <p class="text-sm">{{ text }}</p>
  </router-link>
</template>

<script lang="ts">
import MIcon from "@/components/MIcon.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MIcon
  },
  props: {
    icon: String,
    text: String,
    to: String,
    select: Boolean
  }
})
export default class MNavItem extends Vue {
  icon!: string;
  text!: string;
  to!: string;
  select = false;

  get dynamicWrapClass(): string {
    if (this.select) {
      return "text-primary-500";
    } else {
      return "text-gray-500";
    }
  }
}
</script>
